export const DEVICE_BREAKPOINTS = {
  mobile: 0,
  tablet: 768,
  desktop: 992
};

export const MAX_GRID_WIDTH = "1372px";
export const TABLET_GRID_BREAKPOINT = `${DEVICE_BREAKPOINTS.tablet}px`;
export const DESKTOP_GRID_BREAKPOINT = `${DEVICE_BREAKPOINTS.desktop}px`;
